import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { closeModal } from '@/function/function.js';
import Vue from 'vue';
import VueHtmlToPaper from 'vue-html-to-paper';

const options = {
    name: '_blank',
    specs: [
        'fullscreen=yes',
        'titlebar=yes',
        'scrollbars=yes'
    ],
    styles: [
        'https://shilo-clinique.appligestion.com/style.css',
        'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
    ]
}

Vue.use(VueHtmlToPaper, options);

extend("required", {
    ...required,
    message: "Ce champ est obligatoire !",
});

export default {
    name: 'caisse-sortie',
    components: {
        ValidationProvider,
        ValidationObserver,
    },
    props: ['userCompte', 'userId', 'solde', 'modal_title'],
    data() {
        return {
            loading: false,
            types: [{
                "nom": "JOHN",
            }],

            // Duplique les lignes de sorties (Libelle + Montant)
            sorties: [{
                "libelle": "",
                "montant": ""
            }],
            ligne_budget: "",
            type_depense: "",
            type_depenses: [],

            files: [],
            preuve_depense: '',
            preuve_is_empty: false,

            user_role: 0,
            compte_id: 0,
            user_id: 0,

            btn_disable: false,
            is_solde_lessen: false,
            is_plafond_reached: false,

            date: new Date(),
            curr_month: '',

            solde_r: 0,
        }
    },

    watch: {
        ligne_budget() {
            const data = {
                month: this.curr_month,
                role_id: this.ligne_budget.role_id,
                ligne_id: this.ligne_budget.id
            }
            this.getSoldeCourantLigne(data)
        }
    },

    computed: {
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        activeRole() {
            return this.$store.getters['activeRole'];
        },

        montant_total() {
            let somme = 0
            this.sorties.forEach((data) => {
                somme += parseInt(data.montant)
            })
            return somme;
        },

        liste_ligne_budgetaire_by_role() {
            return this.$store.getters['liste_ligne_budgetaire_by_role']
        },

        cumul_depense_ligne_budgetaire() {
            return this.$store.getters['cumul_depense_ligne_budgetaire']
        },

        solde_restant_ligne_budgetaire() {
            return this.$store.getters['solde_restant_ligne_budgetaire']
        },
    },

    mounted() {
        this.curr_month = this.date.getMonth()+1

        if (this.userCredentials.user.roles.length > 0) {
            this.user_id = this.userCredentials.user.id
            this.user_role = this.userCredentials.user.roles[0].nom;

            if (this.activeRole.nom == 'ROLE_CAISSIERE') {
                this.compte_id = 1 //  Caisse principale
            } else if (this.activeRole.nom == 'ROLE_CAISSIERE_INTERMITENT') {
                this.compte_id = 4 //  Caisse 1 (Infirmier)
            } else if (this.activeRole.nom == 'ROLE_COMPTABLE') {
                this.compte_id = 3 //  Comptabilité
            }
        }

        this.$store.dispatch('getLigneBudgetaire', this.activeRole.id)
    },

    methods: {
        handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			/*
				Adds the uploaded file to the files array
			*/
			this.files = []
			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push(uploadedFiles[i]);
			}

            this.preuve_depense = this.files[0];
		},

        /**
         * Ajouter plus de sortie
         */
        addMoreSortie: function() {
            this.sorties.push({ libelle: '', montant: '' });
        },

        /**
         * Retire plus de sortie
         */
        removeMoreSortie(index) {
            this.sorties.splice(index, 1)
        },

        /**
         * Submit form
         */
        async onSubmit() {
            const isValid = await this.$refs.form.validate();
            if (!isValid) {
                return;
            }

            if (this.montant_total > this.solde_restant_ligne_budgetaire.solde_restant) {
                this.is_solde_lessen = true
                return;
            }

            if (this.preuve_depense == '') {
                this.preuve_is_empty = true
                return;
            }

            // if (this.ligne_budget.plafond < (this.montant_total + this.cumul_depense_ligne_budgetaire)) {
            //     this.is_plafond_reached = true
            //     return;
            // }

            this.loading = true;

            let data = {
                user_id: this.userId,
                compte_id: this.userCompte,
                montant: this.montant_total,
                ligne_budgetaire: this.ligne_budget.libelle,
                ligne_budgetaire_id: this.ligne_budget.id,
                preuve: this.preuve_depense,
                sortie_len: this.sorties.length,
            }

            let form_data = new FormData();
            for (let key in data) {
                form_data.append(key, data[key])
            }

            let i = 0;
            for (const s of this.sorties) {
                form_data.append("dep_libelle_"+i, s['libelle'])
                form_data.append("dep_montant_"+i, s['montant'])
                i++
            }

            this.$store.dispatch("storeLigneSortieDeCaisse", form_data).then((response) => {
                if (response.success) {
                    this.successToast("Dépense effectuée avec succès")
                    // notifier au component parent la modification de la valeur de dépense total
                    this.$emit('updateDepenseAfterCreation')

                    this.$refs.close_modal.click()
                    this.$refs.form.reset()
                    this.sorties = [{
                        "libelle": "",
                        "montant": ""
                    }]
                    this.ligne_budget = ""
                } else {
                    if (response.code == 500) {
                        this.warningToast("Une erreur s'est produite ! Merci de réessayer plus tard.")
                    }
                }
                this.loading = false;
            }).catch(() => {
                this.warningToast("Une erreur s'est produite ! Merci de réessayer plus tard.")
                this.loading = false;
            })
        },

        /**
         * Close Modal
         * @param {*} selector 
         */
        closeModal(selector) {
            closeModal.closeModal(selector);
        },

        doSuccessMsg: function() {
            this.$toasted.show('La sortie de caisse a été enregistrée', {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'success'
            })
        },
        doErrorMsg: function(msg) {
            this.$toasted.show(msg, {
                action: [{
                    text: 'X',
                    onClick: (e, toastObject) => {
                        toastObject.goAway(0);
                    }
                }],
                position: 'top-center',
                duration: 5000,
                theme: 'toasted-primary',
                type: 'error'
            })
        },

        clearError() {
            this.is_plafond_reached = false
            this.is_solde_lessen = false
        },

        calcCumulDepense(ligne_budgetaire) {
            this.$store.dispatch('getSommeLigneBudgetaire', ligne_budgetaire)
        },

        getSoldeCourantLigne(data) {
            this.$store.dispatch('getSoldeCourantLigneBudgetaire', data).then(() => {
                this.solde_r = this.solde_restant_ligne_budgetaire.solde_restant
            })
        }
    }
}